<div #container class="vertical-container">

    <div  class="scroll-left" *ngIf="showScrolling" [style.top]="scrollerY">
      <button mat-fab color="primary" (click)="scroll(100)">
        <mat-icon>chevron_left</mat-icon>
      </button>
    </div>

    <div  class="scroll-right" *ngIf="showScrolling" [style.top]="scrollerY">
      <button mat-fab color="primary" (click)="scroll(-100)">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

  <div class="graph-box" #graphbox>  

    <div class="range-selector">
      <mat-form-field class="date-picker" appearance="fill" *ngIf="currentRange === 'custom'"  >
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="picker"  (dateChange)="onCustomRangeDateChange()" [(ngModel)]="rangeStartDate" placeholder="Choose a date">
        <mat-datepicker-toggle matSuffix  [startAt]="datePickerDate" [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="date-picker" appearance="fill" *ngIf="currentRange === 'custom'"  >
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="picker" (dateChange)="onCustomRangeDateChange()" [(ngModel)]="rangeEndDate" placeholder="Choose a date">
        <mat-datepicker-toggle matSuffix  [startAt]="datePickerDate" [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="fill"  class="range-type">
        <mat-label>Range</mat-label>
        <mat-select (selectionChange)="onRangeSelected()" [(value)]="currentRange">
          <mat-option *ngFor="let rangeOption of rangeOptions" [value]="rangeOption.value">
            {{rangeOption.displayName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="trackable-type-heading" *ngIf="getHeatMap()">Symptoms & Treatments</div>
    <div class="legend">
      <div class="legendItems">
        <div class="legendItem" *ngFor="let item of getLegendItems(); let i = index">
          <div class="legendBullet" [style.background-color]="getSchemaColor(i)"></div>
          {{item}}
        </div>
      </div>
    </div>
    <div class="data-container">
    <div class="trackable-labels">
        <div *ngFor="let label of getLabels()" class="heatmap-label" style="--label-height: {{cellHeight}}px;">{{label}}</div>
        <div *ngIf="getEvidenceLabels().length > 0" class="evidence-heading">Evidence</div>
        <div *ngFor="let label of getEvidenceLabels()" class="bargraph-label" style="--bar-label-height: {{barHeight}}px;">{{label}}</div>
    </div>
    
    <div class="results-container">
      <div #scrollcontainer class="scroll-container"  [scrollLeft]="scrollerX">

        <div  *ngIf="getHeatMap()" class="heatmap-container">
          <huddy-heat-map   
            [view]="view"
            [scheme]="colorScheme"
            [legend]="false"
            [animation]="true"
            [legendPosition]="'below'"
            [showXAxisLabel]="false"
            [showYAxisLabel]="false"
            [xAxis]="true"
            [trimXAxisTicks]="true"
            [trimYAxisTicks]="true"
            [yAxis]="false"
            [results]="getHeatMap()"
            >
          </huddy-heat-map>
          </div> 

          <div class="trackable-spacer"></div>

          <div class="bar-style" *ngFor="let evidence of getEvidence()">
            <ngx-charts-bar-vertical
              [view]="barView"
              [scheme]="barColorScheme"
              [results]="evidence.series"
              [gradient]="gradient"
              [xAxis]="true"
              [yAxis]="false"
              [legend]="false"
              [showGridLines]="true"
              [showXAxisLabel]="false"
              [showYAxisLabel]="false"
              [xAxisLabel]="xAxisLabel"
              [noBarWhenZero]="false"
              [yAxisLabel]="">
            </ngx-charts-bar-vertical>
          </div>
        </div>
      </div>
    </div>  
  </div>

</div>